import type { ReactNode } from "react";

export function NoxusFormHelperText({ children }: { children: ReactNode }) {
  return (
    <p className="text-xs font-regular text-muted-foreground">{children}</p>
  );
}
